/**
 * A RECEITA DO CAMPO (09/10/2026): a cor de input, select e textarea, num lugar só (guia §2).
 *
 * Até aqui cada controle trazia a própria receita escrita à mão: 55 receitas de cor diferentes nos arquivos que usam a
 * casca, medidas em 09/10/2026, cinco delas cobrindo 73% dos controles. Eram azul-marinho (slate-700/800/900), e o
 * foco, quando havia, era o laranja do acento velho. O HUB segue a Central: superfície `central-elevado`, borda
 * `central-borda`, texto `central-texto` e foco em `primary`, sem anel.
 *
 * - `campo` leva a LARGURA da borda (`border`) junto da cor, para quem usa não precisar lembrar dela.
 * - `campoSomenteLeitura` é um degrau abaixo (`central-fundo`, texto fraco): campo travado não pode parecer editável.
 * - Tamanho, raio, espaçamento e `focus:outline-none` ficam em quem chama: aqui mora só a cor.
 *
 * A catraca `check-receita-de-controle` conta o controle que ainda tem receita azul escrita à mão, com teto que só desce.
 */
export const campo = 'border bg-central-elevado border-central-borda text-central-texto focus:border-primary';
export const campoSomenteLeitura = 'border bg-central-fundo border-central-borda text-central-texto-fraco cursor-not-allowed';

/**
 * O campo com uma cor de ESTADO (10/10/2026): obrigatório vazio, valor inválido, filtro ligado, pendente. A cor do
 * estado é de quem chama e entra no lugar da borda (e, quando dada, do texto) do `campo`; sem estado, devolve o `campo`
 * exato. O resto (superfície e foco `primary`) é o da peça: o estado muda a borda, não a receita inteira.
 *
 *   className={`w-full px-3 py-2 rounded-lg ${campoComEstado(!form.email?.trim() && 'border-red-500/60')}`}
 */
export function campoComEstado(borda?: string | false | null, texto?: string | false | null): string {
  return `border bg-central-elevado ${borda || 'border-central-borda'} ${texto || 'text-central-texto'} focus:border-primary`;
}
